<template>
  <!-- FitToast中的icon传空(不能不传，因为它有default值)，强制不走<FitIcon>,而使用template -->
  <FitToast v-show="toast.show" :size="toast.size" icon=""
    :class="`fit-font-30 wphk-components-toast ${toast.className} ${emptyIconClass}`"
    :showDotLine="false">
    <div class="weui-mask_transparent"></div>
    <template v-slot:icon v-if="!isEmptyIcon">
      <OkIcon class="ok-icon-container" v-if="toast.type === 'tick'"
        color="#fff" :width="120" aria-hidden="true" />
      <ErrorIcon class="error-icon-container"
        v-if="toast.type === 'exclamation'" color="#fff" :width="96"
        aria-hidden="true" />
    </template>
    <span v-html="toast.title"></span>
  </FitToast>
</template>
<script lang="ts">
import { FitToast } from '@tencent/wphk-ui';
import { Component, Prop, Vue } from 'vue-property-decorator';
import store from './business/store';
import { OkIcon, ErrorIcon } from '@tencent/wphk-icon-vue';
import { ToastType } from './business/business';
@Component({
  components: {
    FitToast,
    OkIcon,
    ErrorIcon,
  },
})
export default class FitLoading extends Vue {
  public toast = store.toast;
  get isEmptyIcon() {
    return this.toast.type === ToastType.Empty;
  }
  get emptyIconClass() {
    return this.isEmptyIcon ? 'empty-toast' : '';
  }
  @Prop({ default: 'tick' }) public type!: string;
}
</script>
<style lang="less" scoped>
@rem: 200rem;

.wphk-components-toast {
  &:not(.empty-toast) {
    /deep/ .weui-toast__content {
      min-height: 96 / @rem;
      margin-bottom: 0;
    }

    .ok-icon-container {
      margin-bottom: -10 / @rem;
    }

    .error-icon-container {
      margin-bottom: 15 / @rem;
    }
  }
}
</style>
